import { useEffect } from "react";

const SITE_URL = "https://lnz-projects.preview.emergentagent.com";
const DEFAULT_OG_IMAGE =
  "https://customer-assets.emergentagent.com/job_7157ae0d-6d42-458a-b5d2-8f22b0a1e387/artifacts/wgqswldl_LNZ%20Front.png";

function setMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Per-route SEO controller.
 * Updates <title>, meta description, canonical link and Open Graph / Twitter tags.
 *
 * @param {Object} opts
 *   - title: string (becomes the document title)
 *   - description: string (meta description + og:description + twitter:description)
 *   - path: string (route path, used for canonical + og:url)
 *   - image: string (optional, overrides og:image)
 *   - type: string (og:type, defaults to "website")
 *   - keywords: string (optional, meta keywords)
 */
export default function useSEO({ title, description, path = "/", image, type = "website", keywords } = {}) {
  useEffect(() => {
    if (title) document.title = title;

    const url = `${SITE_URL}${path}`;
    const ogImage = image || DEFAULT_OG_IMAGE;

    setMeta("name", "description", description);
    if (keywords) setMeta("name", "keywords", keywords);

    setMeta("property", "og:type", type);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", ogImage);

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", ogImage);

    setLink("canonical", url);
  }, [title, description, path, image, type, keywords]);
}
